import { combineReducers } from 'redux';
import dashboard from './dashboard/reducer';
export default combineReducers({ dashboard });
